import { AnyAction, Dispatch } from 'redux';
import { HealerUserProfileGateway } from '../../../infra/adapters/luminara/userprofile/healer-user-profile-gateway';
import { HealerSettingsAction } from '../../../store/reducers/healer-settings.reducer';
import { AppState } from '../../../store/store';
import { ThunkResult } from '../shared/ThunkResult';
import { setLoggedUserProfile } from '../../../store/selectors/global.selector';

export const loadMyProfileAsHealer = (): ThunkResult<{
  userProfileGateway: HealerUserProfileGateway;
}> => {
  return async (dispatch: Dispatch<AnyAction>, getState: () => AppState, { userProfileGateway }) => {
    try {
      const healerData = await userProfileGateway.getMyUserProfileAsHealer();
      dispatch({ type: 'LOAD_HEALER_USER_PROFILE_SUCCESS', payload: healerData } as HealerSettingsAction);
      dispatch(setLoggedUserProfile(healerData));
    } catch (error: any) {
      dispatch({ type: 'LOAD_HEALER_USER_PROFILE_FAILURE', payload: error } as HealerSettingsAction);
    }
  };
};
